(() => {
  window.DigitalizModules = window.DigitalizModules || {};
  if (window.DigitalizModules.productGalleryVariantSync) return;
  window.DigitalizModules.productGalleryVariantSync = true;

  const api = window.DigitalizProductGalleryVariantSync || {};

  function getSlides(root) {
    return [...root.querySelectorAll("[data-product-gallery-slide]")].filter(
      (slide) => !slide.classList.contains("is-clone") && slide.getAttribute("data-splide-clone") !== "true"
    );
  }

  function getSlideIndexByData(root, attr, value) {
    if (value === null || value === undefined || value === "") return -1;
    const num = Number(value);
    const slides = getSlides(root);
    return slides.findIndex((slide) => Number(slide.dataset[attr]) === num);
  }

  function normalizeShopifyImagePath(path) {
    return (path || "").replace(/_(\d+)x(\d+)?(?=\.[a-zA-Z]+$)/, "");
  }

  function normalizeUrl(url) {
    if (!url) return "";
    const value = String(url).trim();
    if (!value) return "";
    try {
      const parsed = new URL(value, window.location.origin);
      return normalizeShopifyImagePath(`${parsed.origin}${parsed.pathname}`);
    } catch (error) {
      return normalizeShopifyImagePath(value.split("?")[0]);
    }
  }

  function getVariantSlideMap(root) {
    if (root.__digitalizVariantSlideMap instanceof Map) {
      return root.__digitalizVariantSlideMap;
    }

    const node = root.querySelector("[data-variant-slide-map]");
    const map = new Map();
    if (!node) {
      root.__digitalizVariantSlideMap = map;
      return map;
    }

    try {
      const list = JSON.parse(node.textContent || "[]");
      list.forEach((item) => {
        const id = Number(item?.id);
        if (!Number.isFinite(id) || id <= 0) return;

        const rawSlideIndex = item?.slide_index;
        const slideIndex =
          rawSlideIndex === null || rawSlideIndex === undefined || rawSlideIndex === ""
            ? null
            : Number(rawSlideIndex);

        map.set(id, {
          slideIndex,
          mediaId: Number(item?.media_id),
          imageId: Number(item?.image_id),
          position: Number(item?.position)
        });
      });
    } catch (error) {
      // Keep empty map on malformed JSON.
    }

    root.__digitalizVariantSlideMap = map;
    return map;
  }

  function getSlideIndexFromMap(root, variantId) {
    const id = Number(variantId);
    if (!Number.isFinite(id) || id <= 0) return -1;

    const mapped = getVariantSlideMap(root).get(id);
    if (!mapped) return -1;

    if (Number.isFinite(mapped.slideIndex) && mapped.slideIndex >= 0) {
      return mapped.slideIndex;
    }

    const byMediaId = getSlideIndexByData(root, "mediaId", mapped.mediaId);
    if (byMediaId >= 0) return byMediaId;

    const byImageId = getSlideIndexByData(root, "imageId", mapped.imageId);
    if (byImageId >= 0) return byImageId;

    const byPosition = getSlideIndexByData(root, "mediaPosition", mapped.position);
    if (byPosition >= 0) return byPosition;

    return -1;
  }

  function getSlideIndexFromVariant(root, variant) {
    if (!variant) return -1;

    const mapIndex = getSlideIndexFromMap(root, variant.id);
    if (mapIndex >= 0) return mapIndex;

    const imageIdCandidates = [variant.featured_image?.id, variant.image_id, variant.image?.id];
    for (const imageId of imageIdCandidates) {
      const idx = getSlideIndexByData(root, "imageId", imageId);
      if (idx >= 0) return idx;
    }

    const mediaIdCandidates = [variant.featured_media?.id, variant.featured_image?.id, variant.image_id];
    for (const mediaId of mediaIdCandidates) {
      const idx = getSlideIndexByData(root, "mediaId", mediaId);
      if (idx >= 0) return idx;
    }

    const positionCandidates = [
      variant.featured_media?.position,
      variant.featured_image?.position,
      variant.image?.position
    ];
    for (const position of positionCandidates) {
      const idx = getSlideIndexByData(root, "mediaPosition", position);
      if (idx >= 0) return idx;
    }

    const slides = getSlides(root);
    const srcCandidates = [
      variant.featured_media?.preview_image?.src,
      variant.featured_media?.src,
      variant.featured_image?.src,
      variant.image?.src
    ]
      .map(normalizeUrl)
      .filter(Boolean);

    if (!srcCandidates.length) return -1;

    return slides.findIndex((slide) => {
      const image = slide.querySelector("img");
      const anchor = slide.querySelector("a[href]");
      const sources = [
        slide.dataset.mediaSrc,
        image?.currentSrc,
        image?.getAttribute("src"),
        image?.dataset?.src,
        anchor?.getAttribute("href")
      ]
        .map(normalizeUrl)
        .filter(Boolean);

      return srcCandidates.some((candidate) =>
        sources.some((source) => source.endsWith(candidate) || candidate.endsWith(source))
      );
    });
  }

  api.getSlides = getSlides;
  api.getSlideIndexFromMap = getSlideIndexFromMap;
  api.getSlideIndexFromVariant = getSlideIndexFromVariant;

  window.DigitalizProductGalleryVariantSync = api;
})();
